import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)  //必须有这一行，否则报错

// 创建一个store实例
export default new Vuex.Store({
  state: {
    status: 0,
    isNight:0
  },
  getters: {       //就像计算属性一样，getter 的返回值会根据它的依赖被缓存起来，且只有当它的依赖值发生了改变才会被重新计算。
    getStatus (state) {
      return state.status ? state.status : ''
    },
    getNight (state) {
      return state.isNight ? state.isNight : ''
    },

  },
  mutations: {  
    updateStatus (state, data) { 
      state.status = data
    },
    updateNight (state, data) { 
      state.isNight = data
    }
  },
  actions: {        //actions不是必须的，但是在运用到异步时就要用到actions例如setTimeOut
    updateStatus (context, data) {
      context.commit('updateStatus', data)
    },
    updateNight (context, data) {
      context.commit('updateNight', data)
    },
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js